<template>
  <div class="sonEditLabel">
    <div class="left">
      <!-- 选择区 -->
      <div class="selectionArea">
        <div class="demo-image__preview">
          <span class="title">客户头像</span>
          <el-image
            style="width: 80px; height: 80px"
            :src="row.avatar"
            :preview-src-list="[row.avatar]"
          />
        </div>
        <div class="item only">
          <span class="title">客户昵称</span><el-tag>{{ row.remark }}</el-tag>
        </div>
        <div class="item only">
          <span class="title">归属员工</span>{{ row.employee_name }}
        </div>
        <div class="item only">
          <span class="title">外部客户id</span>{{ row.external_user_id }}
        </div>
      </div>
    </div>
    <div class="right">
      <div style="max-height: 400px; overflow: auto;margin-bottom: 60px;width: 500px;">
        <div v-for="(item,f) in tableData.tags" :key="item.id" style="margin-top:30px">
          <div v-if="item.tag&&item.tag.length>0">
            <!-- <span style="min-width: 50px;" class="title">标签组：</span> -->
            <el-tag type="warning">{{ item.group_name }}</el-tag>
            <div style="margin-top:20px">
              <!-- <span style="min-width: 50px;" class="title">标签：</span> -->
              <el-tag v-for="(son,i) in item.tag" :key="son.id" closable @close="dltTag(f,i)">{{ son.tag_name }}</el-tag>
            </div>
          </div>
        </div>
        <el-tag v-if="tableData.tags && tableData.tags.length === 0">暂无标签</el-tag>
      </div>
      <div class="but">
        <el-button icon="el-icon-plus" circle @click="add" />
      </div>
      <!-- </div> -->
    </div>
    <el-button class="butSucc1" type="primary" @click="sendForm">确定</el-button>

    <el-dialog
      title="添加标签"
      :visible.sync="labeldialog"
      :append-to-body="true"
      width="600px"
      :before-close="handleClose"
    >
      <div class="labeldialog">
        <div style="max-height: 400px; overflow: auto;margin-bottom: 60px;">
          <div v-for="(item,f) in data" :key="item.id" style="margin-top:30px">
            <el-tag type="warning" @click="hint">{{ item.group_name }}</el-tag>
            <div style="margin-top:20px">
              <el-tag v-for="(son,i) in item.children" :key="son.id" :effect="son.tips?'dark':'plain'" @click="gettag(f,son,i)">{{ son.tag_name }}</el-tag>
            </div>
          </div>
        </div>

        <el-button class="butSucc" type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div></template>

<script>

import { externalDetail, corpTag, updateTag } from '@/api/numberTemplatemessage'

export default {
  components: {},
  props: {
    groupLabel: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      tableData: [],
      row: {},
      labeldialog: false,
      ind: null,
      data: [],
      corp_id: [],
      sign: false
    }
  },
  watch: {
    'tableData.tags': {
      handler(newVal) {
        const filteredTags = newVal.filter(item => item.tag && item.tag.length > 0)
        if (filteredTags.length !== newVal.length) {
          this.tableData.tags = filteredTags
        }
      },
      deep: true
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async sendForm() {
      if (!this.sign) {
        return this.$message('您没有做任何操作哦')
      }
      console.log(this.tableData)
      const tag_ids = []
      const tags = this.tableData.tags.filter(v => {
        // console.log('v.tag_id:', v.tag)
        v.tag.map(e => {
          tag_ids.push(e.tag_id)
        })
      })
      console.log('v.tag_id:', tags, tag_ids)
      const res = await updateTag({
        employee_no: this.row.employee_no,
        external_userid: this.row.external_user_id,
        tag_ids
      })
      this.$message.success(res.message)
      this.groupLabel()
    },
    submit() {
      const tableDataCopy = JSON.parse(JSON.stringify(this.tableData))
      this.data.forEach((item) => {
        const existingGroup = tableDataCopy.tags.find(tag => tag.group_id === item.group_id)
        if (existingGroup) {
          item.children.forEach((child) => {
            if (child.tips) {
              const tagExists = existingGroup.tag.some(tag => tag.tag_id === child.tag_id)
              if (!tagExists) {
                existingGroup.tag.push(child)
              }
            } else {
              const tagIndex = existingGroup.tag.findIndex(tag => tag.tag_id === child.tag_id)
              if (tagIndex > -1) {
                existingGroup.tag.splice(tagIndex, 1)
              }
            }
          })
        } else {
          tableDataCopy.tags.push({ ...item, tag: item.children.filter(child => child.tips) })
        }
      })
      this.$forceUpdate()
      this.sign = true
      this.tableData = tableDataCopy
      console.log(' this.tableData:', this.tableData)
      this.labeldialog = false
    },

    hint() {
      this.$message('我是标签组，别点我，选择蓝色标签')
    },
    gettag(f, son, i) {
      // console.log('f, son:', f, son)
      // console.log(this.data[f].children[i], son)
      if (this.data[f].children[i].tips === true) {
        this.data[f].children[i].tips = false
      } else {
        this.data[f].children[i].tips = true
      }
      this.$forceUpdate()
    },
    async  add() {
      this.data = []
      this.labeldialog = true
      const labelData = await corpTag({ corp_id: this.corp_id })
      this.data = labelData.data[0].children

      this.data.forEach((item, i) => {
        this.tableData.tags.forEach(dataItem => {
          if (dataItem.group_id === item.group_id) {
            item.children.forEach((obj, n) => {
              if (dataItem.tag) {
                dataItem.tag.forEach((tagItem, s) => {
                  if (tagItem.tag_id === obj.tag_id) {
                    obj.tips = true
                  }
                })
              }
            })
          }
        })
      })
    },
    handleClose() {
      this.labeldialog = false
    },
    sendr(row, corp_id) {
      this.corp_id = corp_id
      // console.log(row)
      this.row = row
      this.list()
    },
    dltTag(f, i) {
      // console.log('f, i:', f, i)
      this.tableData.tags[f].tag.splice(i, 1)
      this.sign = true
      // console.log(11, this.tableData.tags)
    },
    async list() {
      const labelData = await externalDetail({
        employee_no: this.row.employee_no,
        external_userid: this.row.external_user_id
      })
      // console.log('labelData', labelData)
      this.tableData = labelData.data
      this.tableData.tags = this.tableData.tags.filter(item => item.tag && item.tag.length > 0)
      console.log('this.tableData---', this.tableData)
    }
  }
}
</script>

<style scoped>
/* @import url(); 引入css类 */
.el-tag{
  margin-right:10px
}
.sonEditLabel{
display: flex;

}
.left{
  flex: 1;
}
.right {
  flex: 1;
  position: relative;
  top: 0;
 left: 0;
display: flex;

}
.labeldialog{
  position: relative;
  top: 0;
  left: 0;
}
.butSucc{
  position: absolute;
  right: 50px;
  bottom: -40px;
}
.butSucc1{
  position: absolute;
  right: 50px;
  bottom: 10px;
}
.but{
  position: absolute;
  top: 0;
  right: 200px;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: calc(100% - 10px);
  margin: 10px 10px 10px 0;
}

.title {
  white-space: pre;
       display: inline-block;
       margin-right: 7px;
       min-width: 80px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.only{
  margin-top:30px

}
</style>
